import { useRef } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

import { sendExpandedChartEvent } from 'constants/mixpanelHelper';

import { ExpandableContainerProvider } from 'uiToolkitV1/ExpandableContainerProvider';

import { CandidatesHireTable } from './CandidatesHireTable';
import { LifecycleMeshRecommends } from './components/LifecycleMeshRecommends';
import { LifecycleOverviewSection } from './components/LifecycleOverviewSection';
import { LifecycleSpiderChart } from './components/LifecycleSpiderChart';
import WordCloud from './components/WordCloud';
import { MOCK_SPIDER_CHART_DATA } from './constants';

const SpiderGraphSection = () => (
  <Flex gap={4} w="100%" h="360px">
    <Box w="50%" h="100%">
      <ExpandableContainerProvider
        id="lifeCycleInsightsSpiderGraph"
        isParentDeterminesHeight
        toggleBtnBoxProps={{ top: '3px !important' }}
        onExpand={() => {
          sendExpandedChartEvent({
            eventProperties: {
              source: 'lifecycle',
              type: 'insights',
            },
          });
        }}
      >
        <LifecycleSpiderChart iSpiderChartLoading={false} spiderChartData={MOCK_SPIDER_CHART_DATA} />
      </ExpandableContainerProvider>
    </Box>
    <Box w="50%" h="100%">
      <ExpandableContainerProvider
        id="lifeCycleInsightsWordCloud"
        isParentDeterminesHeight
        toggleBtnBoxProps={{ top: '3px !important' }}
        onExpand={() => {
          sendExpandedChartEvent({
            eventProperties: {
              source: 'lifecycle',
              type: 'insights',
            },
          });
        }}
      >
        <Box h="360px">
          <WordCloud />
        </Box>
      </ExpandableContainerProvider>
    </Box>
  </Flex>
);

export const LifecycleHireIntent = () => {
  const gridRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const currentURL = history.location.pathname;
  const localStorageKey = getUniqueCardKey({ url: currentURL, cardId: 'myCompanyOneOnOneOverview' });
  const isCardOpen = useLocalStorageCards({
    localStorageKey,
    card: 'lifecycleInsightsHire',
    section: 'myCompany',
  });
  const handleChange = (newVal: boolean) => {
    dispatch(
      setIsCardOpen({
        card: 'lifecycleInsightsHire',
        section: 'myCompany',
        isCardOpen: newVal,
        localStorageKey,
      })
    );
    return newVal;
  };
  return (
    <>
      <LifecycleOverviewSection
        open={isCardOpen}
        onOpenChange={handleChange}
        // subTitle="Congratulations on your consistent progress towards your goals! However, there hasn't been notable development in certain competencies this past year. Maven suggests exploring ways to demonstrate the 'Collaboration' competency in your upcoming 1:1. Let's unlock your full potential together!"
        // subTitleColor="success"
        title="Overview"
        // showCaption={pendingReviews?.data.length > 0 && checkNewStaticDataFeaturesEnabled() && !employeeContext}
      >
        <Flex
          borderRadius="8px"
          p={2}
          width="full"
          minHeight="full"
          flexDirection={{ base: 'column', md: 'row' }}
          gap="8px"
        >
          <Flex width="100%">
            <LifecycleMeshRecommends />
          </Flex>
        </Flex>
        <Flex
          borderRadius="8px"
          bg="#F5F7F9"
          p={2}
          width="full"
          minHeight="full"
          flexDirection={{ base: 'column', md: 'row' }}
          gap="8px"
          marginTop="8px"
        >
          <Flex width="100%">
            <SpiderGraphSection />
          </Flex>
        </Flex>
      </LifecycleOverviewSection>
      <Box bg="#FFF" w="100%" h="auto" borderRadius="8px" p="8px" mt="10px">
        <CandidatesHireTable gridRef={gridRef} />
      </Box>
    </>
  );
};
